import {React, useState} from "react";
import { Tooltip } from "@mui/material";
import deleteNode from "../../../Assets/delete_node.svg";
import addNode from "../../../Assets/add_node.svg";
import editNode from "../../../Assets/edit_node.svg";
import closeNodeIcons from "../../../Assets/close_node_icons.svg";
import '../Node_Edge_Components.css';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const NodeIcons = ({ onDelete, onAdd, handleCanvasClick, nodeIconsClose, onPropertiesTabClose, fromWorkflow }) => {
 const [openConfirm, setOpenConfirm] = useState(false);
   const handleDelete = (e) => {
    setOpenConfirm(false);
        e.stopPropagation();
        onPropertiesTabClose();   // Hide the right panel
        onDelete();
    };

  return (
    <>
      <div className="icons">
          <Tooltip title="delete node">
            <img src={deleteNode} className="icon-style" onClick={(e) => {
              e.stopPropagation();
              setOpenConfirm(true);
            }}/>
          </Tooltip>
          {
            !fromWorkflow && (
              <>
          <Tooltip title="add new node">
             <img src={addNode} className="icon-style" onClick={onAdd}/>
          </Tooltip>
          
              <Tooltip title={fromWorkflow ? "edit subflow": "edit event"}>
              <img src={editNode} className="icon-style" onClick={handleCanvasClick}/>
           </Tooltip>
           </>
            )
          }
       
          <div style={{height:'auto', borderLeft:'0px solid white'}}></div>
          {/* <Tooltip title="close node options">
             <img src={closeNodeIcons} className="icon-style closeIcon" onClick={nodeIconsClose}/>
          </Tooltip> */}
  
      </div>
       {/* CONFIRMATION DIALOG */}
            <Dialog
              open={openConfirm}
              onClose={() => setOpenConfirm(false)}
            >
              <DialogTitle>Delete Node</DialogTitle>
      
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to delete?
                </DialogContentText>
              </DialogContent>
      
              <DialogActions>
                <Button onClick={() => setOpenConfirm(false)}>
                  Cancel
                </Button>
      
                <Button
                  color="error"
                  variant="contained"
                  onClick={handleDelete}
                  // onClick={() => {
                  //   setOpenConfirm(false);
                  //   if (typeof onDelete === "function") {
                  //     onDelete(id);
                  //   }
                  // }}
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
    </>
  );
};

export default NodeIcons;
